{
  "pages": {
    "prescriptionListTitle": "Quản lý đơn thuốc",
    "prescriptionCreateTitle": "Tạo đơn thuốc mới",
    "drugListTitle": "Quản lý thuốc",
    "drugAddTitle": "Thêm thuốc",
    "drugEditTitle": "Sửa thuốc",
    "templateListTitle": "Mẫu đơn thuốc",
    "templateAddTitle": "Thêm mẫu đơn thuốc",
    "templateEditTitle": "Sửa mẫu đơn thuốc",
    "prescriptionPermissionDenied": "Bạn không có quyền xem đơn thuốc.",
    "prescriptionCreatePermissionDenied": "Bạn không có quyền tạo đơn thuốc.",
    "prescriptionEditPermissionDenied": "Bạn không có quyền sửa đơn thuốc.",
    "prescriptionEditTitleWithNumber": "Sửa đơn thuốc: {{number}}",
    "drugPermissionDenied": "Bạn không có quyền xem danh mục thuốc.",
    "templatePermissionDenied": "Bạn không có quyền xem mẫu đơn thuốc.",
    "templateAddPermissionDenied": "Bạn không có quyền thêm mẫu đơn thuốc."
  },
  "status": {
    "draft": "Nháp",
    "finalized": "Hoàn tất",
    "cancelled": "Đã hủy",
    "active": "Đang dùng",
    "inactive": "Ngừng dùng"
  },
  "fields": {
    "patient": "Bệnh nhân",
    "patientRequired": "Bệnh nhân *",
    "patientId": "Mã bệnh nhân",
    "doctor": "Bác sĩ",
    "doctorOptional": "Bác sĩ chỉ định",
    "doctorWithName": "BS. {{name}}",
    "treatmentSession": "Buổi điều trị",
    "treatmentSessionOptional": "Buổi điều trị",
    "treatmentSessionFor": "Buổi điều trị của {{name}}",
    "sessionDate": "Ngày buổi điều trị",
    "diagnosis": "Chẩn đoán",
    "instructions": "Hướng dẫn chung",
    "notes": "Ghi chú",
    "drugName": "Tên thuốc",
    "drugNameRequired": "Tên thuốc *",
    "activeIngredient": "Hoạt chất",
    "strength": "Hàm lượng",
    "unit": "Đơn vị tính",
    "usage": "Cách dùng",
    "description": "Mô tả",
    "templateNameRequired": "Tên mẫu *",
    "templateName": "Tên mẫu",
    "patientInstructions": "Hướng dẫn cho bệnh nhân",
    "internalNotes": "Ghi chú nội bộ",
    "createdBy": "Người tạo",
    "createdAt": "Ngày tạo",
    "createdOn": "Ngày tạo",
    "updatedBy": "Người cập nhật",
    "updatedAt": "Ngày cập nhật",
    "updatedOn": "Ngày cập nhật",
    "status": "Trạng thái",
    "prescriptionTemplateOptional": "Đơn thuốc mẫu",
    "usePrescriptionTemplate": "Dùng mẫu đơn thuốc"
  },
  "placeholders": {
    "searchPrescriptions": "Tìm đơn thuốc",
    "searchDrugs": "Tìm theo tên hoặc hoạt chất",
    "searchTemplates": "Tìm mẫu đơn",
    "diagnosis": "Nhập chẩn đoán của bệnh nhân",
    "instructions": "Hướng dẫn chung cho bệnh nhân",
    "drugName": "Nhập tên thuốc",
    "activeIngredient": "Ví dụ: Amoxicillin",
    "strength": "Ví dụ: 500mg",
    "unit": "Ví dụ: Viên, ống, chai",
    "quantity": "Nhập số lượng",
    "drugDescription": "Mô tả thêm về thuốc",
    "usage": "Ví dụ: Uống sau ăn, súc miệng 30 giây...",
    "selectDrug": "Chọn thuốc",
    "selectDoctor": "Chọn bác sĩ chỉ định",
    "selectSession": "Chọn buổi điều trị",
    "templateName": "Nhập tên mẫu đơn",
    "templateDescription": "Mô tả ngắn về mẫu đơn",
    "internalNotes": "Ghi chú nội bộ (không in trên đơn)"
  },
  "table": {
    "prescriptionNumber": "Số đơn",
    "patient": "Bệnh nhân",
    "doctor": "Bác sĩ",
    "medications": "Thuốc",
    "status": "Trạng thái",
    "date": "Ngày",
    "actions": "Thao tác",
    "name": "Tên",
    "drug": "Tên thuốc",
    "drugCatalogName": "Đơn thuốc",
    "unitAbbrev": "DVT",
    "qty": "Số lượng",
    "moreCount": "+{{count}} thuốc khác"
  },
  "sections": {
    "medications": "Thuốc",
    "medicationList": "Danh sách thuốc",
    "medicationsWithCount": "Thuốc ({{count}})",
    "auditInfo": "Thông tin hệ thống"
  },
  "actions": {
    "addRow": "Thêm dòng",
    "addDrug": "Thêm thuốc",
    "addTemplate": "Thêm mẫu",
    "createPrescription": "Tạo đơn thuốc",
    "creatingPrescription": "Đang tạo đơn thuốc...",
    "saveTemplate": "Lưu mẫu",
    "updateTemplate": "Cập nhật mẫu",
    "saveChanges": "Lưu thay đổi",
    "updatePrescription": "Cập nhật đơn thuốc",
    "finalize": "Hoàn tất",
    "print": "In",
    "downloadPdf": "Tải PDF",
    "downloadPrescription": "Tải đơn thuốc",
    "printPrescription": "In đơn thuốc",
    "saving": "Đang lưu...",
    "updating": "Đang cập nhật...",
    "adding": "Đang thêm...",
    "viewDetails": "Xem chi tiết",
    "deleteRow": "Xóa dòng"
  },
  "filters": {
    "trigger": "Bộ lọc",
    "title": "Lọc đơn thuốc",
    "status": "Trạng thái",
    "doctor": "Bác sĩ",
    "dateRange": "Khoảng ngày",
    "dateRangePlaceholder": "Chọn khoảng ngày",
    "clinic": "Chi nhánh",
    "patient": "Bệnh nhân",
    "selectDoctor": "Chọn bác sĩ",
    "selectClinic": "Chọn chi nhánh",
    "allStatuses": "Tất cả trạng thái",
    "selectStatus": "Chọn trạng thái",
    "allDoctors": "Tất cả bác sĩ",
    "allClinics": "Tất cả chi nhánh"
  },
  "details": {
    "prescriptionTitle": "Chi tiết đơn thuốc",
    "drugTitle": "Chi tiết thuốc",
    "templateTitle": "Chi tiết mẫu đơn",
    "noPrescriptionSelected": "Chưa chọn đơn thuốc",
    "noTemplateSelected": "Chưa chọn mẫu đơn",
    "noDrugSelected": "Chưa chọn thuốc",
    "unknownPatient": "Không rõ bệnh nhân",
    "unknownDrug": "Không rõ thuốc",
    "notAvailable": "N/A"
  },
  "validation": {
    "patientRequired": "Vui lòng chọn bệnh nhân",
    "drugRequired": "Vui lòng chọn thuốc",
    "quantityMin": "Số lượng phải từ 1 trở lên",
    "drugNameRequired": "Vui lòng nhập tên thuốc",
    "drugNameTooLong": "Tên thuốc không được quá {{max}} ký tự",
    "drugActiveIngredientTooLong": "Hoạt chất không được quá {{max}} ký tự",
    "drugStrengthTooLong": "Hàm lượng không được quá {{max}} ký tự",
    "drugUnitTooLong": "Đơn vị tính không được quá {{max}} ký tự",
    "drugUsageTooLong": "Cách dùng không được quá {{max}} ký tự",
    "drugDescriptionTooLong": "Mô tả không được quá {{max}} ký tự",
    "templateNameRequired": "Vui lòng nhập tên mẫu",
    "templateNameTooLong": "Tên mẫu không được quá {{max}} ký tự",
    "templateDescriptionTooLong": "Mô tả không được quá {{max}} ký tự",
    "instructionsTooLong": "Hướng dẫn không được quá {{max}} ký tự",
    "fixFixHighlighted": "Vui lòng sửa các trường được đánh dấu"
  },
  "dialogs": {
    "confirmDeleteTitle": "Xác nhận xóa",
    "deletePrescriptionConfirm": "Bạn có chắc muốn xóa đơn thuốc \"{{name}}\"? Hành động này không thể hoàn tác.",
    "deleteConfirm": "Bạn có chắc muốn xóa \"{{name}}\"? Hành động này không thể hoàn tác."
  },
  "template": {
    "inactiveDrugsWarning": "Một số thuốc trong mẫu này không còn hoạt động. Vui lòng kiểm tra lại danh sách thuốc.",
    "replaceConfirm": "Áp dụng mẫu này sẽ thay thế danh sách thuốc và hướng dẫn hiện tại. Tiếp tục?"
  },
  "print": {
    "disabledTooltip": "Chỉ in được đơn thuốc đã hoàn tất",
    "printFailed": "Không thể in đơn thuốc",
    "downloadFailed": "Không thể tải đơn thuốc",
    "downloadSuccess": "Đã tải PDF đơn thuốc"
  },
  "toasts": {
    "prescriptionsLoadFailed": "Không tải được danh sách đơn thuốc",
    "prescriptionUpdated": "Đã cập nhật đơn thuốc",
    "prescriptionUpdateFailed": "Cập nhật đơn thuốc thất bại",
    "prescriptionDeleted": "Đã xóa đơn thuốc",
    "prescriptionDeleteFailed": "Xóa đơn thuốc thất bại",
    "prescriptionFinalized": "Đã hoàn tất đơn thuốc",
    "prescriptionFinalizeFailed": "Hoàn tất đơn thuốc thất bại",
    "prescriptionCreated": "Đã tạo đơn thuốc",
    "prescriptionCreateFailed": "Tạo đơn thuốc thất bại",
    "drugsLoadFailed": "Không tải được danh sách thuốc",
    "drugAdded": "Đã thêm thuốc",
    "drugAddFailed": "Thêm thuốc thất bại",
    "drugUpdated": "Đã cập nhật thuốc",
    "drugUpdateFailed": "Cập nhật thuốc thất bại",
    "drugDeleted": "Đã xóa thuốc",
    "drugDeleteFailed": "Xóa thuốc thất bại",
    "drugInPrescription": "Không thể xóa vì thuốc đang nằm trong đơn thuốc (nháp hoặc đã hoàn tất)",
    "drugInTemplate": "Không thể xóa vì thuốc đang nằm trong mẫu đơn thuốc",
    "templatesLoadFailed": "Không tải được danh sách mẫu đơn",
    "templateAdded": "Đã thêm mẫu đơn thuốc",
    "templateAddFailed": "Thêm mẫu đơn thất bại",
    "templateUpdated": "Đã cập nhật mẫu đơn thuốc",
    "templateUpdateFailed": "Cập nhật mẫu đơn thất bại",
    "templateDeleted": "Đã xóa mẫu đơn thuốc",
    "templateDeleteFailed": "Xóa mẫu đơn thất bại"
  },
  "empty": {
    "prescriptions": "Không tìm thấy đơn thuốc",
    "drugs": "Không tìm thấy thuốc",
    "templates": "Không tìm thấy mẫu đơn"
  },
  "misc": {
    "patientMeta": "Mã: {{id}} • SĐT: {{phone}}",
    "loadingPatients": "Đang tải bệnh nhân...",
    "loadingDoctors": "Đang tải bác sĩ...",
    "loadingSessions": "Đang tải buổi điều trị...",
    "loadingTemplates": "Đang tải mẫu đơn...",
    "noPatientsAvailable": "Không có bệnh nhân",
    "noDoctorSelected": "Chưa chọn bác sĩ",
    "noPractitionersAvailable": "Không có bác sĩ",
    "noSession": "Không có buổi điều trị",
    "noSessionsForPatient": "Bệnh nhân chưa có buổi điều trị",
    "noTemplate": "Không dùng mẫu",
    "noTemplatesAvailable": "Không có mẫu đơn thuốc",
    "noActiveDrugsAvailable": "Chưa có thuốc đang dùng",
    "dash": "—"
  },
  "hints": {
    "addDrugsBeforeTemplate": "Thêm thuốc trong danh mục (trạng thái đang dùng) trước khi lập mẫu đơn."
  }
}
